import { createApp } from 'vue';
import { extend } from 'lodash-es';
import MarkerComponent from './Marker.vue';

// Because of SSR :
// eslint-disable-next-line no-undef
const parentClass = typeof google !== 'undefined' && google.maps ? google.maps.OverlayView : function () {};

/**
 * This class inherits from google map OverlayView. We need to do so because a basic marker can only be a picture
 * and we want it to be a div with html. OverlayView provides a way to do so
 */
class Marker extends parentClass {
  /**
   * Inits the Marker with its coordinate and the map vue instance
   * @param selectionItemId
   * @param coordinate
   * @param price
   * @param mapVueInstance
   */
  constructor(selectionItemId, coordinate, price, mapVueInstance) {
    super();

    this.selectionItemId = selectionItemId;
    this.price = price;
    this.coordinate = coordinate;
    // eslint-disable-next-line no-undef
    this.latlng = typeof google !== 'undefined' && google.maps ? new google.maps.LatLng(coordinate.lat, coordinate.lng) : null;

    this.mapVueInstance = mapVueInstance;
    this.setMap(mapVueInstance);
  }

  /**
   * Method called by maps api. Create the div using vuejs and append it the overlay layer.
   */
  draw() {
    if (!this.div) {
      const description = extend(MarkerComponent, {
        marker: this,
      });

      // Create and mount Vue 3 app
      const app = createApp(description);
      this.vueInstance = app.mount(document.createElement('div'));
      this.div = this.vueInstance.$el;
      this.getPanes().overlayImage.appendChild(this.div);
    }

    // Draw could have been called on map drag, so we need to update position
    this.updatePosition();
  }

  /**
   * When the map is dragged, the marker position changes. We pass the new position
   * to the vue instance of the marker, so it can move itself.
   */
  updatePosition() {
    if (!this.latlng || !this.getProjection()) {
      return;
    }
    const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
    if (point) {
      this.vueInstance.setBasePoint(point);
    }
  }

  /**
   * Return the marker position, as gps coordinate (does not change)
   * @return {google.maps.LatLng}
   */
  getPosition() {
    return this.latlng;
  }

  /**
   * Remove the marker from the map
   */
  remove() {
    this.setMap(null);
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
      // Unmount the Vue app properly
      // eslint-disable-next-line no-unused-expressions
      this.vueInstance.$unmount && this.vueInstance.$unmount(); // Optional if you extended Vue instance lifecycle
    }
  }
}

export default Marker;
